import {useMemo} from "react";
import {getLocale} from "umi";
import {useIntl} from "@@/plugin-locale/localeExports";

export const useAccumulateOptionsByFilterValue = (filterValue:any,haveDate=false) => {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    const getOptions = (filterValue: any, haveDate: boolean) => {
      const options = [];
      if(haveDate) {
        options.push(
          {
            value: 'date',
            disabled:true,
            text: formatMessage({ id: 'common_by_Date' }),
          }
        );
      }
      if (filterValue?.zone) {
        options.push(
          {
            value: 'zone',
            text: formatMessage({ id: 'common_by_Zone' }),
          }
        );
      }
      if (filterValue?.region) {
        options.push(
          {
            value: 'region',
            text: formatMessage({ id: 'common_by_Region' }),
          }
        );
        options.push(
          {
            value: 'country',
            text: formatMessage({ id: 'common_by_Country' }),
          }
        );
      }
      if (filterValue?.channel) {
        options.push(
          {
            value: 'channel',
            text: formatMessage({ id: 'common_by_Channel' }),
          }
        );
      }
      if (filterValue?.system) {
        options.push(
          {
            value: 'system',
            text: formatMessage({ id: 'common_by_System' }),
          }
        );
      }
      if (filterValue?.bundle) {
        options.push(
          {
            value: 'bundle',
            text: formatMessage({ id: 'common_by_Bundle' }),
          }
        );
      }
      if (filterValue?.lang) {
        options.push(
          {
            value: 'language',
            text: formatMessage({ id: 'common_by_Language' }),
          }
        );
      }
      return options;
    }
    if (filterValue?.newFilter) {
    const { filterValue: filterVal } = filterValue ?? {};
    return getOptions(filterVal, haveDate);
    }
    return getOptions(filterValue, haveDate);
  }, [getLocale(), filterValue])
}
